// image icons
import iterior from "../../../assets/interior.png";
import landscape from "../../../assets/lanscape.png";
import estimate from "../../../assets/estimate.png";
import consultation from "../../../assets/consultation.png";

export const we_do_details = [
  {
    icon: iterior,
    title: "Taxi Services",
    description:
      "Reliable and comfortable transportation tailored to your needs",
    route: "",
  },
  {
    icon: landscape,
    title: "Ride-Sharing",
    description:
      "Convinient, affordable and eco-friendly travel options for you.",
    route: "",
  },
 
];
